import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  checkAuthProvider,
  loginWithAuthProvider,
  logoutAuthProvider,
  registerWithAuthProvider,
} from '@actions/auth';

export function useAuth() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const loading = useSelector((state) => state.authLoading);

  const checkAuth = useCallback(async () => {
    await dispatch(checkAuthProvider());
  }, [dispatch]);

  const login = useCallback(() => {
    dispatch(loginWithAuthProvider());
  }, [dispatch]);

  const register = useCallback(() => {
    dispatch(registerWithAuthProvider());
  }, [dispatch]);

  const logout = useCallback(() => {
    dispatch(logoutAuthProvider());
  }, [dispatch]);

  return {
    user,
    loading,
    login,
    register,
    logout,
    checkAuth,
    isAuthenticated: !!user
  };
}
